import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.2 1.4A1 1 0 0 1 6 1h12a1 1 0 0 1 .8.4l3 4a1 1 0 0 1 .2.6v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a1 1 0 0 1 .2-.6zM6.5 3 5 5h14l-1.5-2zM4 20V7h16v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1m5-10a1 1 0 1 0-2 0 5 5 0 1 0 10 0 1 1 0 1 0-2 0 3 3 0 0 1-6 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }